import { Button } from "shared/Components/button";
import { globalVariables } from "helper/globalVariables";
import { ChevronDown } from "helper/icons";
import { useRef, useState } from "react";
import useOutsideClick from "helper/useOutsideClick";

export const ActionButton = ({
  actionButtonOptions,
  dynamicHeight,
  width = "w-[150px]",
  transform,
  onClickOption,
  label,
  loading,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const handleOptionClick = (option) => {
    onClickOption?.(option);
    setIsOpen(false);
  };
  useOutsideClick(ref, ()=> setIsOpen(false));

  return (
    <div ref={ref} className="relative">
      <Button
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        label={label ? label : globalVariables.action}
        width={width}
        icon={ChevronDown}
        prefix={false}
        disabled={loading}
      />
      {isOpen && (
        <div
          className={`origin-top-left absolute left-0 mt-2 rounded-lg border-2 border-gray-400 ${
            !dynamicHeight ? "max-h-[185px]" : ""
          } overflow-y-scroll bg-white ${width} z-[100] ${transform}`}
          style={{ boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)' }}
        >
          {actionButtonOptions?.map((option, index) => (
            <button
              key={option}
              onClick={(event) => {
                event.stopPropagation();
                // if (option === "Edit") {
                handleOptionClick(option);
                // }/
              }}
              className={`block w-full text-left px-4 py-4 text-sm text-gray-700 hover:bg-primary/50 hover:text-white ${
                index !== actionButtonOptions?.length - 1 ? "border-b" : ""
              } border-gray-200 max-[400px]:text-xs`}
              role="menuitem"
            >
              {option}
            </button>
          ))}
          <div
            className="py-1"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          ></div>
        </div>
      )}
    </div>
  );
};
